<template>
  <div id="app">
    <router-view  v-if="isRouterAlive"/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    provide(){
         return{
           reload:this.reload
         }
    },
    data(){
      return {
        isRouterAlive:true
      }
    },
    methods:{
      reload(){
        this.isRouterAlive=false
        this.$nextTick(function(){
          isRouterAlive:true
        })
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "~@/common/css/variable.styl"
  #app
    min-width: 1200px
    height: 100%
    background: $color-background-grey
  @media screen and (min-width: 320px) and (max-width: 480px){//解决手机屏适配问题
    #app{
      height: 100%
      background:$color-background-grey
      min-width:100%;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?1746cd5d